"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Logger = exports.getLogger = exports.unfreezeLogLevel = exports.freezeLogLevel = exports.setLogLevel = exports.setExceptionReporter = exports.LOG_LEVEL = void 0;
exports.LOG_LEVEL = {
    NOTSET: 0,
    DEBUG: 1,
    INFO: 2,
    WARNING: 3,
    ERROR: 4,
    NOLOGS: 5,
};
var loggers = {};
var logLevel = exports.LOG_LEVEL.ERROR;
var logLevelFrozen = false;
var exceptionReporter = null;
var setExceptionReporter = function (reporter) {
    exceptionReporter = reporter;
};
exports.setExceptionReporter = setExceptionReporter;
var sendException = function (msg) {
    if (exceptionReporter) {
        exceptionReporter(msg);
    }
};
var setLogLevel = function (level) {
    if (logLevelFrozen)
        return;
    logLevel = level;
};
exports.setLogLevel = setLogLevel;
var freezeLogLevel = function () {
    logLevelFrozen = true;
};
exports.freezeLogLevel = freezeLogLevel;
var unfreezeLogLevel = function () {
    logLevelFrozen = false;
};
exports.unfreezeLogLevel = unfreezeLogLevel;
var getLogger = function (name) {
    if (!loggers[name]) {
        loggers[name] = new Logger(logLevel, name);
    }
    return loggers[name];
};
exports.getLogger = getLogger;
var Logger = /** @class */ (function () {
    function Logger(logLevel, prefix) {
        this.logLevel = logLevel;
        this.prefix = '[ARCANA_DKG]';
        if (prefix) {
            this.prefix += "[" + prefix + "]";
        }
    }
    Logger.prototype.log = function (level, message, params) {
        if (params === void 0) { params = {}; }
        this.internalLog(exports.LOG_LEVEL[level], message, params);
    };
    Logger.prototype.info = function (message, params) {
        if (params === void 0) { params = {}; }
        this.internalLog(exports.LOG_LEVEL.INFO, message, params);
    };
    Logger.prototype.debug = function (message, params) {
        if (params === void 0) { params = {}; }
        this.internalLog(exports.LOG_LEVEL.DEBUG, message, params);
    };
    Logger.prototype.warn = function (message, params) {
        if (params === void 0) { params = {}; }
        this.internalLog(exports.LOG_LEVEL.WARNING, message, params);
    };
    Logger.prototype.error = function (message, params) {
        if (params === void 0) { params = {}; }
        this.internalLog(exports.LOG_LEVEL.ERROR, message, params);
        sendException(JSON.stringify({ message: message, params: params }));
    };
    Logger.prototype.internalLog = function (level, message, params) {
        var logMessage = this.prefix + " - " + this.getLogLevelName(level) + " " + this.getTime() + " " + message + " \n[PARAMS]: " + JSON.stringify(params) + "\n        ";
        this.consoleLog(level, logMessage);
    };
    Logger.prototype.getLogLevelName = function (level) {
        switch (level) {
            case exports.LOG_LEVEL.DEBUG:
                return 'DEBUG';
            case exports.LOG_LEVEL.INFO:
                return 'INFO';
            case exports.LOG_LEVEL.WARNING:
                return 'WARN';
            case exports.LOG_LEVEL.ERROR:
                return 'ERROR';
            default:
                return 'NOTSET';
        }
    };
    Logger.prototype.getTime = function () {
        return new Date().toLocaleTimeString();
    };
    Logger.prototype.consoleLog = function (level, message) {
        if (level < this.logLevel) {
            return;
        }
        switch (level) {
            case exports.LOG_LEVEL.DEBUG:
                console.debug(message);
                break;
            case exports.LOG_LEVEL.WARNING:
                console.warn(message);
                break;
            case exports.LOG_LEVEL.ERROR:
                console.error(message);
                break;
            case exports.LOG_LEVEL.INFO:
                console.info(message);
                break;
            default:
                console.log(message);
        }
    };
    return Logger;
}());
exports.Logger = Logger;
